import { useToast } from "@/components/ui/use-toast";
import { Module, PATH_PROJECT_CONTRACTOR_VISITS } from "@/constants";
import { useMutationWithErrorHandling } from "@/hooks/useMutationWithErrorHandling";
import { ContractorVisitsService } from "@/modules/projects/services/contractorVisits";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const useDeleteContractorVisitMutation = (contractorVisitId: string) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const navigate = useNavigate();

  return useMutationWithErrorHandling({
    mutationFn: async () =>
      await ContractorVisitsService.delete(contractorVisitId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [Module.ContractorVisits, contractorVisitId],
      });
      queryClient.invalidateQueries({
        queryKey: [Module.ContractorVisits],
      });
      toast({
        title: t("projectContractorVisits.success.delete"),
      });
      navigate(PATH_PROJECT_CONTRACTOR_VISITS);
    },
    errorTitle: t("projectContractorVisits.errors.delete"),
  });
};
